import { useState,useEffect } from "react";
import UserContext from "./UserContext";
import { APIs, API_BASE_URL, AuthRoutes, roleAccess, commonAllowedRolesAccess, USERTYPES, NonAuthRoutes, SERVICEURL, SHARED_SERVICEURL } from "../../constants/Constants";
import axios from "axios";
import Moment from "moment";
import { encryptData } from "../../helpers/RSAUtility";
import axiosInterceptor from "../../helpers/Interceptor";
import { v4 as uuidv4 } from 'uuid';
axios.defaults.withCredentials = true;

const UserState = (props) => {

  const queryString = window.location.search;
  // Create a URLSearchParams object
  const urlParams = new URLSearchParams(queryString);

 

  const [contextSwitchUser , setContextSwitchUser] = useState(false);
  const [unautherizedAccessObj, setShowUnauthunautherizedAccessObj] = useState({
    showError:false,
    errorMsg: ""
  });

  const [contextSwitchStudyviewer , setContextSwitchStudyviewer] = useState(false);

  const [userDetail, setUserDetail] = useState({});
  const [token, setToken] = useState("");
  const [authenticated, setAuthenticated] = useState(false);
  const [userId, setUserId] = useState("");
  const [username, setUsername] = useState("");
  const [roles, setRoles] = useState([]);
  const [email, setEmail] = useState("");
  const [showSuccessToast, setSuccessToast] = useState(false);
  const [qcReviewer, setQcReviewer] = useState();
  const [name, setName] = useState("");
  const [firmId, setFirmId] = useState();
  const [firmName, setFirmName] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [lastResetPasswordDate, setLastResetPasswordDate] = useState(null);
  const [editorName, setEditorName] = useState("froala");
  const [userSettings, setUserSettings] = useState(null);
  const [isActiveData, setIsActiveData] = useState(true);
  const [radiologistType, setRadiologistType] = useState(null);
  const [enableLlmReport , setEnableLlmReport] = useState(false);
  const [twoFAGlobalEnable , setTwoFAGlobalEnable] = useState(false);
  const [twoMonitorEnabled, setTwoMonitorEnabled] = useState(false);
  const [customerSupportNumber,setcustomerSupportNumber]=useState("");
  const [privilegedFirmDoctor , setPrivilegedFirmDoctor] = useState(false);
  const [peerReviewAdmin, setPeerReviewAdmin] = useState(false);
  const [peerReviewEvaluator, setPeedReviewEvaluator] = useState(false);
  const [resetPasswordAllowed,setResetPasswordAllowed]=useState(false);
  const [ disableSubmitforResident, setDisableSubmitforResident ] = useState(false);

  const MACHINE_ID_KEY = "machineid";
  const getMachineId = () => {
    let machineId = localStorage.getItem(MACHINE_ID_KEY);
    if (!machineId) {
        machineId = uuidv4();
        localStorage.setItem(MACHINE_ID_KEY, machineId);
    }
    return machineId;
  };

  const signin = async (username, password) => {
    try {
      
      const machineId = getMachineId();
      console.log("Machine id- "+machineId);
      const response = await axios.post(
        API_BASE_URL + "auth/signin",
        {
          // const response = await axios.post("https://enl81exnk1zih.x.pipedream.net/",{
          username: username,
          password: password,
        },
        {
          // withCredentials: true,
          headers: { "Content-Type": "application/json", 
            "X-machineId":machineId
          },
          // credentials: 'include'
        }
      );

      console.log("--- User State Response -----", response);
      if(response.data.result !== "Pending"){
        setToken(response.data.data.accessToken);
        setUserId(response.data.data.id);
        setUsername(response.data.data.username);
        setEmail(response.data.data.email);
        setRoles(response.data.data.roles);
        setcustomerSupportNumber(response.data.data.customerSupportNumber);
        setPrivilegedFirmDoctor(response.data.data.privilegedFirmDoctor);
        setPeerReviewAdmin(response.data.data.peerReviewAdmin);
        setPeedReviewEvaluator(response.data.data.peerReviewEvaluator);
        setResetPasswordAllowed(response.data.data.passwordResetAllowed);
        setDisableSubmitforResident(response.data.data?.disableSubmit);
        setFirmId(response.data.data.firmId);
        setIsActiveData(process.env.REACT_APP_PARTITION_MODE == "false" ? true : response.data.data.activeData);
        if(response.data.data?.firmName != undefined && response.data?.data?.firmName != null){
          setFirmName(response.data.data.firmName);
        }
        setQcReviewer(response.data.data.qcReviewer);
        setName(
          response.data.data.name == undefined
            ? username
            : response.data.data.name
        );
        setShowConfirmation(response.data.data.showConfirmation);
        setLastResetPasswordDate(response.data.data.lastResetPasswordDate);
        if(response?.data?.data?.userSettings?.length > 6 && response?.data?.data?.userSettings != ""){
          setUserSettings(JSON.parse(response.data.data.userSettings));
        }
        if (
          response.data.data.editorName != undefined &&
          response.data.data.editorName != null
        ) {
          setEditorName(response.data.data.editorName);
        } else {
          setEditorName("ckeditor");
        }
        
        setAuthenticated(true);
        localStorage.setItem("refreshToken", response.data.data.refreshToken);
        localStorage.setItem("username", response.data.data.username);
        localStorage.setItem("forceReset", response.data.data.forceReset);
        localStorage.setItem(
          "redirectOnLogin",
          response.data.data.redirectOnLogin
        );
      }
      return response;
    } catch (error) {
      return error.response;
    }
  };

  const loadByUsername = async () => {
  
    try {
      let response = null;
      if(NonAuthRoutes.CONTEXTSWITCHSTUDYLIST === window.location.pathname){

         // Get a specific query parameter
        const clientId = urlParams.get('clientId');
        const secretKey = urlParams.get('secretKey');
        const patientId = urlParams.get('patientId');

        response =  await axiosInterceptor.post(
          API_BASE_URL + SHARED_SERVICEURL + "/open-api/authenticate" ,{
            data: {
              clientId: clientId,
              secretKey: secretKey,
              patientId: patientId
          
            },
            
          }
        );
        
        if(response.status == 200 && response.data.result=="FAILURE"){
          setShowUnauthunautherizedAccessObj (()=>{
            const newItem = {...unautherizedAccessObj};
            newItem.showError = true;
            newItem.errorMsg = response.data.message;
            return newItem;
            });
        }
        setContextSwitchUser(true);
        
      }else if(NonAuthRoutes.CONTEXTSWITCHSTUDYVIEWER === window.location.pathname){
            // Get a specific query parameter
            const clientId = urlParams.get('clientId');
            const secretKey = urlParams.get('secretKey');
            const studyId = urlParams.get('studyId');

            response =  await axiosInterceptor.post(
              API_BASE_URL + SHARED_SERVICEURL + "/open-api/authenticate" ,{
                data: {
                  clientId: clientId,
                  secretKey: secretKey,
                  studyId: studyId
              
                },
                
              }
            );
            if(response.status == 200 && response.data.result=="FAILURE"){
              setShowUnauthunautherizedAccessObj (()=>{
                const newItem = {...unautherizedAccessObj};
                newItem.showError = true;
                newItem.errorMsg = response.data.message;
                return newItem;
                });
            }
            setContextSwitchUser(true);
            setContextSwitchStudyviewer(true);
      }
      else{
        
         response = await axiosInterceptor.post(
          API_BASE_URL + APIs.LOADUSERDATA
        );
      }
      // console.log("User data response ", response);
      if (response.status === 200 && response.data.result === "Success") {
        // console.log("--- User State Response -----", response);
        setUserId(response.data.data.id);
        setUsername(response.data.data.username);
        setEmail(response.data.data.email);
        setRoles(response.data.data.roles);
        setAuthenticated(true);
        setContextSwitchUser(response.data.data.contextSwitchUser);
        setName(
          response.data.data.name == undefined
            ? username
            : response.data.data.name
        );
        if(response?.data?.data?.userSettings?.length > 6 && response?.data?.data?.userSettings != ""){
            setUserSettings(JSON.parse(response.data.data.userSettings));
        }
        setFirmId(response.data.data.firmId);
        setIsActiveData(process.env.REACT_APP_PARTITION_MODE == "false" ? true : response.data.data.activeData);
        if(response.data.data?.firmName != undefined && response.data?.data?.firmName != null){
          setFirmName(response.data.data.firmName);
        }
        setEditorName("froala");  
        setQcReviewer(response.data.data.qcReviewer);
        setShowConfirmation(response.data.data.showConfirmation);
        setLastResetPasswordDate(response.data.data.lastResetPasswordDate);
        setRadiologistType(response.data.data.radiologistType);
        setEnableLlmReport(response.data.data?.enableLlmReport);
        setTwoFAGlobalEnable(response.data.data?.twoFAGlobalFlag);
        setcustomerSupportNumber(response.data.data.customerSupportNumber);
        setPrivilegedFirmDoctor(response.data.data?.privilegedFirmDoctor);
        setPeerReviewAdmin(response.data.data?.peerReviewAdmin);
        setPeedReviewEvaluator(response.data.data?.peerReviewEvaluator);
        setResetPasswordAllowed(response.data.data?.passwordResetAllowed);
        setDisableSubmitforResident(response.data.data?.disableSubmit);
        return true;
      }
    } catch (error) {
      console.log("user data ", error);
      return false;
      // if (error.response.status === 403)
      //   window.location.assign(APIs.REDIRECTLOGOUT);
    }
  };

  const authenticate2FAOTP = async (username, otp) => {
    try {
      const response = await axios.post(API_BASE_URL + APIs.AUTHENTICA2FATEOTP, {
        data: {
          twoFaAuth: {
            username,
            otp,
          },
        },
      });
      console.log(response);

      setToken(response.data.data.accessToken);
        setUserId(response.data.data.id);
        setUsername(response.data.data.username);
        setEmail(response.data.data.email);
        setRoles(response.data.data.roles);
        setFirmId(response.data.data.firmId);
        setIsActiveData(process.env.REACT_APP_PARTITION_MODE == "false" ? true : response.data.data.activeData);
        if(response.data.data?.firmName != undefined && response.data?.data?.firmName != null){
          setFirmName(response.data.data.firmName);
        }
        setQcReviewer(response.data.data.qcReviewer);
        setName(
          response.data.data.name == undefined
            ? username
            : response.data.data.name
        );
        setShowConfirmation(response.data.data.showConfirmation);
        setLastResetPasswordDate(response.data.data.lastResetPasswordDate);
        if(response?.data?.data?.userSettings?.length > 6 && response?.data?.data?.userSettings != ""){
          setUserSettings(JSON.parse(response.data.data.userSettings));
        }
        if (
          response.data.data.editorName != undefined &&
          response.data.data.editorName != null
        ) {
          setEditorName(response.data.data.editorName);
        } else {
          setEditorName("ckeditor");
        }
        
        setAuthenticated(true);
        localStorage.setItem("refreshToken", response.data.data.refreshToken);
        localStorage.setItem("username", response.data.data.username);
        localStorage.setItem("forceReset", response.data.data.forceReset);
        localStorage.setItem(
          "redirectOnLogin",
          response.data.data.redirectOnLogin
        );

      return response;
    } catch (error) {
      if (error.response.status === 403)
        window.location.assign(APIs.REDIRECTLOGOUT);
      else return error.response;
    }
  };

  
  

  const authenticate = async () => {
    return await signin(encryptData("dtfirmadmin"), encryptData("Admin@123"));
  };

  const getConsistentDateFormat = (date) => {
    if (Moment(date).isValid()) {
      return Moment(date).format("DD-MMM-YY hh:mm A");
    } else {
      return "No Date";
    }
  };

  const checkForUserAccess = () => {
    if(process.env.REACT_APP_HYBRID_MODE == "true"){
        return;
    }
  try{
    const nonAuthRoutes = Object.values(NonAuthRoutes);
    if (nonAuthRoutes.includes(window.location.pathname)) {
      return;
    }
    if (roles[0] !== undefined) {
      const allowedRoutes = roleAccess[roles[0]];
      if(commonAllowedRolesAccess.includes(window.location.pathname) 
        || allowedRoutes == undefined 
      || roles[0] === USERTYPES.ADMIN){
        return;
      }
      for (const route of allowedRoutes) {
        const regex = new RegExp('^' + route.replace(/:[^/]+/g, '[^/]+') + '$');
        //console.log("---Testing for ----",regex.test(window.location.pathname));
        if (regex.test(window.location.pathname)) {
          return;
        }
      }
      if (window.location.pathname !== AuthRoutes.NOT_ALLOWED) {
        window.location.assign(AuthRoutes.NOT_ALLOWED);
      }
    }
  }catch(e){
    console.log("---Exception---",e);
    return;
  }
    
  };

  useEffect(() => {
      checkForUserAccess()
  }, [roles[0],window.location.pathname]);


  useEffect(() => {
    const reloadPage = localStorage.getItem('reloadPageDataSwitch');
    if (reloadPage) {
      localStorage.removeItem('reloadPageDataSwitch');
      window.location.reload();
    }
  }, [isActiveData]);

  return (
    <UserContext.Provider
      value={{
        signin,
        loadByUsername,
        userDetail,
        setUserDetail,
        token,
        authenticate,
        authenticated,
        userId,
        email,
        username,
        roles,
        showSuccessToast,
        setSuccessToast,
        firmId,
        firmName,
        name,
        qcReviewer,
        showConfirmation,
        editorName,
        getConsistentDateFormat,
        lastResetPasswordDate,
        userSettings, 
        setUserSettings,
        checkForUserAccess,
        isActiveData,
        setIsActiveData,
        radiologistType,
        unautherizedAccessObj,
        contextSwitchUser,
        contextSwitchStudyviewer,
        enableLlmReport,
        authenticate2FAOTP,
        twoFAGlobalEnable,
        customerSupportNumber,
        privilegedFirmDoctor,
        peerReviewAdmin,
        peerReviewEvaluator,
        resetPasswordAllowed,
        disableSubmitforResident,
      }}
    >
      {props.children}
    </UserContext.Provider>
  );
};

export default UserState;
